import {Component, ElementRef, OnInit, ViewEncapsulation} from '@angular/core';
import {
	AbstractControl,
	FormBuilder,
	FormGroup,
	Validators
} from '@angular/forms';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Subject} from 'rxjs/Subject';

import {Location} from '@angular/common';

import {ActiveTabDirective} from '../active-tab.directive';
import {Speaker} from '../models/speaker';
import {SpeakerService} from '../speaker.service';
import {UserMsgService} from '../user-msg.service';

enum View {
	RESEARCHER = 1,
	STUDENT = 2
}

@Component({
	selector : 'app-search',
	templateUrl : './search.component.html',
	styleUrls : [ './search.component.css' ],
	encapsulation: ViewEncapsulation.None
})
export class SearchComponent implements OnInit {
	objectKeys = Object.keys;
	queryForm: FormGroup;
	query: AbstractControl;
	searchTerm = '';
	count = 0;
	view = View.STUDENT;
	instances: any[];
	searches = new Array<string>();
	tabIndex = 1;
	searchTerm$ = new Subject<string>();
	message;
	routeQueryParamsSubscription: any;
	isTabChange: boolean = false;
	progressBarStyle: any;
	
	constructor(fb: FormBuilder, private speaker: SpeakerService,
				private route: ActivatedRoute, private router: Router,
				private uMsg: UserMsgService, private location: Location) {
		this.queryForm = fb.group({'query' : [ '', Validators.required ]});
		
		this.searchTerm$.subscribe(data => {
			const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
			if (data && data.length > 0) {
				queryParams['query'] = data;
				//  this.router.navigate([ '/search' ], {queryParams : queryParams, replaceUrl : true});
			}
			this.router.navigate([ '/search' ], {queryParams : queryParams, replaceUrl : true});
		});
		
		this.speaker.search(this.searchTerm$).subscribe(res => {
			this.searchTerm = res['term'];
			this.count = res['count'];
			
		});
		
		// this.speaker.statsChange.subscribe(stats => {});
		
		this.instances = [];
		
		this.query = this.queryForm.controls['query'];
		
		this.location.subscribe(x => this.isTabChange = true);
		
		this.routeQueryParamsSubscription = this.route.queryParams.subscribe(params => {
			const queryVal = params['query'];
			//     console.log(params);
			this.query.setValue(queryVal);
			
			if (!this.isTabChange)
				this.searchTerm$.next(queryVal);
			let view = "";
			switch(params['display']) {
				case undefined:
					view = "RES";
					break;
				case "concordance":
					view = "Concordance";
					break;
				case "gender":
					view = "Gender";
					break;
				case "age":
					view = "Age";
					break;
				case "socialclass":
					view = "Social";
					break;
				case "regions":
					view = "Map";
					break;
				case "speakers":
					view = "Speakers";
					break;
				case "summary":
					view = "Summary";
					break;
				case "resources":
					view = "Resources";
					break;
			}
			this.speaker.changeView(view, {});
			this.isTabChange = false;
		});
		
		this.speaker.tabChange.subscribe((res) => {
			let queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
			switch(res) {
				case 'RES':
					delete queryParams['display'];
					break;
				case 'Concordance':
					queryParams['display'] = 'concordance';
					break;
				case 'Gender':
					queryParams['display'] = 'gender';
					break;
				case 'Age':
					queryParams['display'] = 'age';
					break;
				case 'Social':
					queryParams['display'] = 'socialclass';
					break;
				case 'Map':
					queryParams['display'] = 'regions';
					break;
				case 'Speakers':
					queryParams['display'] = 'speakers';
					break;
				case 'Summary':
					queryParams['display'] = 'summary';
					break;
				case 'Resources':
					queryParams['display'] = 'resources';
					break;
			}
			this.router.navigate([ '/search' ], { queryParams : queryParams });
			this.isTabChange = true;
		});
		this.speaker.progressSubject.subscribe((res) => {
			this.doProgressBar();
		});
		this.doProgressBar();
	}
	
	onSubmit(form: any): void {
		console.log('you submitted value:', form.query);
		if (form.query !== '') {
			this.searchTerm$.next(form.query);
		}
	}
	
	filterChange(event) {
		this.searchTerm$.next(this.searchTerm);
	}
	
	/*  onChildClick(event) {
    console.log(event.src, event.event);
    switch (event.src) {
    case 'CHART-gender':
      console.log(event.event);
      this.speaker.filterValues['gender'] =
          [ event.event.element._model.label ];
        this.speaker.filterValues['source'] =  
          [ 'BNC' + event.event.element._model.datasetLabel ];
      this.filterChange(undefined);
      break;
    case 'SPEAKER':
      this.speaker.searchEntries(this.searchTerm, event.event.data['ID'], 0, this.speaker.limit)
          .subscribe(res => {
            this.searchTerm = res['term'];
            this.count = res['count'];
          });
      break;
    default:
      break;
    }
    this.tabIndex = 0;
  }
	 */
	clearFilters(event) {
		this.speaker.clearFilters(this.searchTerm);
		this.filterChange(undefined);
	}
	
	ngOnInit() {}
	
	doProgressBar() {
		let self = this;
		if (self.speaker.activeSearch && Object.keys(self.speaker.progress).length > 0) {
			let total = 0;
			for (let index of Object.keys(self.speaker.progress)) {
				total += self.speaker.progress[index].start / self.speaker.progress[index].total;
			}
			total /= Object.keys(self.speaker.progress).length;
			total *= 100;
			if (total > Number(self.progressBarStyle.width.replace("%", "")))
				self.progressBarStyle = {width: total + "%", "background-color": "rgb(200, 200, 200)"};
		} else {
			self.progressBarStyle = {width: "0%"};
		}
	}
}



// WEBPACK FOOTER //
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/src/app/search/search.component.ts